var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-content',[_c('div',{staticClass:"shadow-sm rounded p-4"},[_c('transfer-form',{attrs:{"form_data":_vm.form_data,"form_meta_data":_vm.form_meta_data,"on_submit":_vm.transfer}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }